module.exports = __webpack_public_path__ + "static/media/ico-dots.36289bb4.svg";